/**
 * @flow
 */
import EmbeddableButton from 'components/@home/drawers/AppDrawer/Form/EmbeddableButton';
import CopyField from 'components/controls/CopyField';
import React, { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';

type Props = {
  app: Object,
};

const EmbeddableButtonCopy = ({ app }: Props) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    const virtualDiv = document.createElement('div');
    const root = createRoot(virtualDiv);
    flushSync(() => {
      root.render(<EmbeddableButton app={app} />);
    });
    setValue(virtualDiv.innerHTML);
    root.unmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- render static embed HTML once on mount
  }, []);

  return <CopyField value={value} />;
};

export default EmbeddableButtonCopy;
